import React from 'react';
import { Link } from 'react-router-dom';
import MarketingNav from './MarketingNav';

function LandingHero() {
  return (
    <header className="hero" id="top">
      <div className="wrap">
        <MarketingNav activeLink="home" />
        <div className="hero-inner">
          <div className="eyebrow" style={{ color: 'var(--cream)' }}>
            AI-Powered Lead Nurturing
          </div>
          <h1>
            Thoughtful Touches
            <br />
            <em>Without the Thinking</em>
          </h1>
          <p className="lede">
            AI-powered nurturing that delivers timely, personal touchpoints — automatically. Stay top
            of mind with content your prospects actually care about, without the manual work.
          </p>
          <div className="cta">
            <Link to="/login" className="btn btn-cream">
              Login
            </Link>
            <Link to="/contact-us" className="btn btn-ghost">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
      <div className="scrollcue">
        <span>Scroll</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>
    </header>
  );
}

export default LandingHero;
